import React, { useState } from 'react';
import classnames from 'classnames';
import DivButton from '../a11y/DivButton';
import { t } from '../../utils/i18n';
import Paragraph from '../elements/Paragraph';
import ButtonText from '../elements/ButtonText';
import { baseXUnit, color } from '../../styles/theme';
import IconText from './IconText';

const ExpandableContent: React.FunctionComponent<{
  showExcerpt?: boolean;
  onClick?: () => void;
}> = ({ showExcerpt, onClick, children }) => {
  const [showContent, setShowContent] = useState(false);
  const showContentAndTriggerClick = () => {
    setShowContent(true);
    onClick && onClick();
  };
  return (
    <div className="expandable-content" data-cy="expandable-content">
      {!showContent && showExcerpt && (
        <DivButton onClick={showContentAndTriggerClick}>
          <div className="excerpt-content" data-testid="excerpt-content">
            <Paragraph>{children}</Paragraph>
            <div className="excerpt-overlay" />
          </div>
        </DivButton>
      )}
      {!showContent && (
        <DivButton onClick={showContentAndTriggerClick}>
          <IconText icon="nav-expand" iconColor="purple-light">
            <div className="button-text-container">
              <ButtonText variant="primary">{t('Lue lisää')}</ButtonText>
            </div>
          </IconText>
        </DivButton>
      )}
      <div
        className={classnames('content', { 'content--visible': showContent })}
        data-testid="content"
      >
        <Paragraph>{children}</Paragraph>
      </div>

      {/*language=CSS*/}
      <style jsx>{`
        .button-text-container {
          padding-top: ${baseXUnit(0.5)};
        }
        .content {
          display: none;
        }
        .excerpt-content {
          position: relative;
          height: ${baseXUnit(7)};
          overflow-y: hidden;
        }
        .excerpt-overlay {
          position: absolute;
          top: 0;
          width: 100%;
          height: 100%;
          background-image: linear-gradient(
            to bottom,
            rgba(255, 255, 255, 0),
            ${color.white}
          );
        }
        .content--visible {
          display: block;
        }
      `}</style>
    </div>
  );
};

export default ExpandableContent;
